import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { addClass } from '../../../Libraries/helpers';

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);

        const url = `${window.location.pathname}${pathname}`

        window.dataLayer.push({
            event: 'PageView',
            url,
        });
    }, [pathname]);

    useEffect(() => {
        addClass('html', 'instant-scroll')
    }, [])

    return null;
}
